export default __webpack_public_path__ + "static/media/SanathanTextile_Dec21'3509.8aba2a12.jpg";